<template>
  <div>
    <AButton @click="changeToDev">切换到开发</AButton>
    <AButton @click="changeToTest">切换到测试</AButton>
    <AForm :label-col="labelCol" :wrapper-col="wrapperCol" v-if="!connected">
      <AFormItem label="服务器">
        <AInput v-model="form.url" />
      </AFormItem>
      <AFormItem label="用户ID">
        <AInput v-model="form.userId" placeholder="最多允许输入10位" />
        <AButton @click="setToken">生成Token</AButton>
      </AFormItem>
      <AFormItem label="token">
        <AInput v-model="form.token" disabled />
      </AFormItem>
      <AFormItem label="上传文件地址">
        <AInput v-model="form.uploadServer" />
      </AFormItem>
      <AFormItem label="下载文件地址">
        <AInput v-model="form.downloadServer" />
      </AFormItem>
      <AFormItem label="视频流媒体服务器地址">
        <AInput v-model="form.videoServer" />
      </AFormItem>
      <AFormItem label="视频信令服务器地址">
        <AInput v-model="form.videoWS" />
      </AFormItem>
      <ACol>
        <AButton @click="init">创建连接</AButton>
      </ACol>
    </AForm>
    <AForm :label-col="labelCol" :wrapper-col="wrapperCol" v-if="connected">
      <AButton @click="disConnect">断开连接</AButton>
      <AFormItem label="用户ID">{{ form.userId }}</AFormItem>
      <SendBox
        ref="send"
        @send="doSend"
        :info="form"
        @sendFile="sendFile"
        @sendImage="sendImage"
        @callVideo="callVideo"
        @callAudio="callAudio"
        @callShare="callShare"
      />
      <AFormItem>
        <ReceiveBox :msgs="receiveMessage" />
      </AFormItem>
    </AForm>
    <CallBox
      :instance="instance"
      :meetingId="meetingId"
      :calling="calling"
      :isCaller="isCaller"
      :isAudio="isAudio"
      :isShare="isShare"
      @accept="acceptCall"
      @refuse="refuseCall"
      @hangup="hangupCall"
      :value="callBox"
    />
  </div>
</template>

<script>
import NW from "@/sdk/NW";
import ReceiveBox from "@/components/ReceiveBox";
import SendBox from "@/components/SendBox";
import CallBox from "@/components/CallBox";
import { getToken } from "@/sdk/getToken";

export default {
  name: "ConnectBox",
  props: ["user"],
  components: { SendBox, ReceiveBox, CallBox },
  data() {
    return {
      isAudio: false,
      isShare: false,
      calling: false,
      isCaller: false,
      callBox: false,
      connected: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        debug: true,
        token: "25885d47cf6d481c96efbfb1c7c82744",
        url: "",
        videoServer: "",
        userId: 111111,
        uploadServer: "",
        downloadServer: "",
        videoWS: ""
      },
      meetingId: "",
      callFromUserId: "",
      receiveMessage: [],
      instance: null
    };
  },

  methods: {
    changeToTest() {
      this.form.url = "wss://172.31.187.50:5261";
      // this.form.uploadServer = "https://172.31.187.50";
      // this.form.downloadServer = "https://172.31.187.50";
    },
    changeToDev() {
      this.form.url = "wss://172.31.129.191:5261/im";
      // this.form.uploadServer = "http://172.31.185.192:8088";
      // this.form.downloadServer = "http://172.31.185.192:8089";
    },
    disConnect() {
      this.instance.destroy();
      this.instance = null;
      this.calling = false;
      this.isAudio = false;
      this.isShare = false;
      this.isCaller = false;
      this.callBox = false;
      this.connected = false;
      this.meetingId = "";
      this.callFromUserId = "";
      this.receiveMessage = [];
    },
    async setToken() {
      const token = await getToken(this.form.userId);
      this.form.token = token;
    },
    acceptCall() {
      const controlName = this.isAudio ? "acceptAudio" : (this.isShare ? "acceptShare" : "acceptVideo");
      this.instance.control(controlName, {
        to: this.callFromUserId,
        content: {
          meetingId: this.meetingId
        }
      });
      this.calling = true;
    },
    refuseCall(command) {
      let to = this.callFromUserId;
      if (this.isCaller) {
        to = this.$refs.send.form.to;
      }
      this.instance.control(command, {
        to
      });
      this.isCaller = false;
      this.calling = false;
      this.callBox = false;
    },
    hangupCall(command) {
      let to = this.callFromUserId;
      if (this.isCaller) {
        to = this.$refs.send.form.to;
      }
      this.instance.control(command, {
        to
      });
      this.isCaller = false;
      this.calling = false;
      this.callBox = false;
    },
    async callVideo({ to }) {
      this.isCaller = true;
      this.isAudio = false;
      this.isShare = false;
      const data = await this.instance.control("callVideo", {
        to
      });
      if (data) {
        this.meetingId = data;
        this.callBox = true;
      }
    },
    async callAudio({ to }) {
      this.isCaller = true;
      this.isAudio = true;
      this.isShare = false;
      const data = await this.instance.control("callAudio", {
        to
      });
      if (data) {
        this.meetingId = data;
        this.callBox = true;
      }
    },
    async callShare({ to }) {
      this.isCaller = true;
      this.isAudio = false;
      this.isShare = true;
      const data = await this.instance.control("callShare", {
        to
      });
      if (data) {
        this.meetingId = data;
        this.callBox = true;
      }
    },
    async sendFile(userId) {
      const msg = await this.instance.sendFileMessage({ to: userId });
      this.receiveMessage.unshift({
        isSend: true,
        // isImage: file === "image",
        isFile: true,
        message: msg
      });
    },
    async sendImage(userId) {
      const msg = await this.instance.sendImageMessage({ to: userId });
      this.receiveMessage.unshift({
        isSend: true,
        isImage: true,
        // isFile: true,
        message: msg
      });
    },
    doSend(msg) {
      const message = this.instance.sendMessage({ ...msg });
      this.receiveMessage.unshift({
        isSend: true,
        message
      });
    },
    async init() {
      const { $message } = this;
      this.instance = new NW({});
      this.instance.setOptions(this.form);
      const res = await this.instance.connect();
      //监听消息
      this.instance.on("message", message => {
        this.receiveMessage.unshift({
          isSend: false,
          message
        });
      });
      this.instance.on("error", function(err) {
        throw err;
      });
      this.instance.on("conflict", function() {
        $message.error("被挤下线啦");
      });
      this.instance.on("refuseAudio", () => {
        $message.error("用户拒绝");
        this.calling = false;
        this.callBox = false;
        this.isCaller = false;
      });
      this.instance.on("refuseVideo", () => {
        this.calling = false;
        this.callBox = false;
        this.isCaller = false;
        $message.error("用户拒绝");
      });
      // 监听视频信号
      this.instance.on("receiveVideo", message => {
        message.content = JSON.parse(message.content);
        console.log('receiveVideo-----', message)
        this.meetingId = message.content.meetingId;
        this.callFromUserId = message.fromUserId;
        this.receiveMessage.unshift({
          message
        });
        this.callBox = true;
        this.isAudio = false;
        this.isShare = false;
      });

      // 监听音频信号
      this.instance.on("receiveAudio", message => {
        message.content = JSON.parse(message.content);
        this.meetingId = message.content.meetingId;
        this.callFromUserId = message.fromUserId;
        this.receiveMessage.unshift({
          message
        });
        this.callBox = true;
        this.isAudio = true;
        this.isShare = false;
      });

      // 监听分享信号
      this.instance.on("receiveShare", message => {
        console.log('receiveShare-----', message)
        message.content = JSON.parse(message.content);
        this.meetingId = message.content.meetingId;
        this.callFromUserId = message.fromUserId;
        this.receiveMessage.unshift({
          message
        });
        this.callBox = true;
        this.isAudio = false;
        this.isShare = true;
      });

      this.instance.on("acceptVideo", message => {
        message.content = JSON.parse(message.content);
        this.receiveMessage.unshift({
          message
        });
        this.meetingId = message.content.meetingId;
        console.log("我应该加入会议了", message.content.meetingId);
        this.calling = true;
      });
      this.instance.on("acceptShare", message => {
        message.content = JSON.parse(message.content);
        this.receiveMessage.unshift({
          message
        });
        this.meetingId = message.content.meetingId;
        console.log("我应该加入会议了", message.content.meetingId);
        this.calling = true;
      });

      this.instance.on("hangupVideo", message => {
        console.log('------hangupVideo-----------', message)
        this.receiveMessage.unshift({
          message
        });
        this.calling = false;
        this.callBox = false;
      });
      this.instance.on("hangupShare", message => {
        console.log('------hangupShare-----------', message)
        this.receiveMessage.unshift({
          message
        });
        this.calling = false;
        this.callBox = false;
      });
      this.instance.on("refuseAudio", message => {
        this.receiveMessage.unshift({
          to: message
        });
        this.calling = false;
        this.callBox = false;
      });
      this.instance.on("refuseVideo", message => {
        this.receiveMessage.unshift({
          to: message
        });
        this.calling = false;
        this.callBox = false;
      });
      this.instance.on("refuseShare", message => {
        this.receiveMessage.unshift({
          to: message
        });
        this.calling = false;
        this.callBox = false;
      });
      this.instance.on("hangupAudio", message => {
        this.receiveMessage.unshift({
          to: message
        });
        this.calling = false;
        this.callBox = false;
      });
      this.instance.on("exit", message => {
        this.calling = false;
        this.callBox = false;
      });

      this.instance.on("image", message => {
        this.receiveMessage.unshift({
          message,
          isImage: true
        });
      });
      this.instance.on("file", message => {
        this.receiveMessage.unshift({
          isFile: true,
          message
        });
      });
      this.connected = true;
    }
  },
  mounted() {
    if (this.user) {
      Object.assign(this.form, this.user);
    }
    setTimeout(() => {
      this.changeToDev()
      this.setToken()
    },500)
  },
  beforeDestroy() {
    this.instance.destroy();
    this.callBox = false;
    this.connected = false;
  }
};
</script>

<style scoped></style>
